import { logger } from '../../../../helpers/logger/logger'

export const checkForNumberOfBets = (
  currentBets: number,
  choosenNumberOfBets: number,
) => {
  if (choosenNumberOfBets > 0) {
    if (currentBets >= choosenNumberOfBets) {
      return true
    }
  }
}

export const checkForStopOnLoss = (stopOnLoss: string, ggr: any) => {
  const loss = Number(stopOnLoss)
  const localGGR = Number(ggr)
  if (loss > 0 && localGGR < 0) {
    const _ggr = -localGGR
    if (_ggr >= loss) {
      logger.log('stop ggr = ' + localGGR + ', stopOnLoss = ' + loss)
      return true
    }
  }
}

export const checkForStopOnWin = (stopOnWin: string, ggr: number) => {
  const win = Number(stopOnWin)
  if (win > 0 && ggr > 0) {
    if (ggr >= win) {
      logger.log('stop ggr=' + ggr + ', stopOnWin=' + win)
      return true
    }
  }
}
export const checkForMaxStake = (stake: string, maxStake: string) => {
  if (Number(maxStake) > 0) {
    if (Number(stake) > Number(maxStake)) {
      logger.log('stake, maxbet', stake, maxStake)
      return true
    }
  }
}
